import { z } from 'zod';
import { orderContext } from '~/app/features/order-middleware/orderMiddleware';
import { formatDate } from '~/utils/formatters';
import { makeLoader, redirect } from '~/utils/routing';

export enum EntryPoint {
  new = 'new',
  existing = 'existing',
  deepLink = 'deepLink',
}

const schema = z.object({
  claimId: z.coerce.number(),
  entryPoint: z.enum(EntryPoint).default(EntryPoint.deepLink),
  store: z.string().default(''),
});

export const { loader, useLoaderData } = makeLoader(({ params, context }) => {
  const { claimId, entryPoint, store } = schema.parse(params);
  const order = context.get(orderContext);
  const claim = order.shippingClaims?.find((c) => c.id === claimId);

  return claim
    ? {
        id: claim.id,
        status: claim.status,
        entryPoint,
        createdOn: formatDate(claim.createdOn),
      }
    : redirect(`/${store}`);
});
